__turbopack_context__.v({
  "dropdown": "mantineSelect-module-scss-module__nFEXBq__dropdown",
  "input": "mantineSelect-module-scss-module__nFEXBq__input",
  "option": "mantineSelect-module-scss-module__nFEXBq__option",
});
